import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import If from '../../utils/If';
import { Button, Dropdown, Loader, Message, MessageHeader, Table } from 'semantic-ui-react';
import Excel from "exceljs";
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { marketplacesBoletoImportAction, marketplacesBoletoPedidosAction } from '../../actions/MarketPlacesActions';
import { ToastContainer, toast } from 'react-toastify';
import styled from 'styled-components';
import moment from 'moment';

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: -10px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
}

`;
const StyledTableRow = styled(Table.Row)`
  &&& {
    &:nth-child(even) {
      background-color: #f7f7f7;
    }

    &:nth-child(odd) {
      background-color: #ffffff;
    }
  }
`;

function Boleto(props) {

    const [dados, setDados] = useState([]);

    const { marketplacesBoletoImportAction, marketplacesBoletoPedidosAction } = props;
    const { boletoarquivojson, boletoarquivojsonloading, boletopedidos, boletopedidosloading } = props;

    useEffect(() => {
        marketplacesBoletoPedidosAction();
    }, [])



    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles.length === 0) return;

        const file = acceptedFiles[0];
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);
        reader.onload = async () => {
            const buffer = reader.result;
            const workbook = new Excel.Workbook();
            await workbook.xlsx.load(buffer);

            let dados = [];

            workbook.eachSheet((sheet) => {
                let header = [];
                sheet.eachRow((row, rowIndex) => {
                    if (rowIndex === 1) {
                        // primeira linha = cabeçalho
                        header = row.values.slice(1); // slice(1) porque row.values[0] é undefined
                    } else {
                        const obj = {};
                        row.values.slice(1).forEach((cell, i) => {
                            obj[header[i]] = cell;
                        });
                        dados.push(obj);
                    }
                });
            });

            // console.log('Array de objetos:', dados);
            setDados(dados);
        };
    }, []);


    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
        acceptedFiles,
        //fileRejectionItems
    } = useDropzone({
        onDrop
        , maxFiles: 1
        //, accept: '.xlsx, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        , accept: '.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const handleSendBoleto = async () => {
        try {
            const res = await marketplacesBoletoImportAction(dados);

            // console.log('status ->', res?.[0]?.status);

            if (res?.[0]?.status === 'OK') {
                toast.success(res[0].menesagem || 'Arquivo processado com sucesso!');
            } else {
                toast.error(res?.[0]?.mensagem || 'Erro ao processar o arquivo!');
            }

        } catch (error) {
            toast.error('Erro ao processar o arquivo!');
            console.error(error);
        }

        // marketplacesBoletoImportAction(dados);
        marketplacesBoletoPedidosAction();
    }
    let array = ''

    if (boletoarquivojson.length > 0) {
        array = boletoarquivojson[0].data
            || boletoarquivojson[0].mensagem
            || boletoarquivojson[0].message
            || boletoarquivojson[0].menesagem;
    }

    const possuiMarcadorTransacao = (array || '').includes('TransaÃ§Ã£o:');

    array = (array || '')
        .split('Transação:')
        .filter(item => item.trim() !== '')
        .map(item => `Transação:${item}`);

    const textoPossuiErro = (texto) => {
        const mensagem = (texto || '')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        return mensagem.includes('erro')
            || mensagem.includes('nenhum pedido encontrado')
            || (mensagem.includes('periodo') && mensagem.includes('nao encontrado'));
    };

    const possuiErroPeriodo = array.some(item => {
        const mensagem = (item || '')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        return mensagem.includes('periodo') && mensagem.includes('nao encontrado');
    });

    const possuiErro = boletoarquivojson.some(item =>
        item?.status && item.status.toString().toUpperCase() !== 'OK'
    ) || array.some(textoPossuiErro);

    if (array.length === 0 && boletoarquivojson.length > 0) {
        array = [possuiErro ? 'Erro ao processar o arquivo!' : 'Arquivo processado com sucesso!'];
    }



    return (
        <div style={{ border: '1px solid #DEDEDF', padding: '20px' }}>
            <ToastContainer className='foo' />
            <div style={{
                border: '1px solid #DEDEDF',
                padding: '20px',
                borderRadius: '6px',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)'
            }}>
                <p style={{ fontWeight: 'bold' }}>Arraste ou selecione o arquivo  para a importa-lo abaixo:</p>
                <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    <p>Clique aqui para selecionar o arquivo</p>
                </div>
                <If test={files.length > 0}>
                    <div>
                        <aside>
                            <h4>Arquivos</h4>
                            <ul>{files}</ul>
                        </aside>
                        <Button color="green" loading={boletoarquivojsonloading} onClick={() => handleSendBoleto()}>Importar</Button>
                    </div>
                </If>
            </div>
            <If test={boletoarquivojson.length > 0}>
                <Message
                    positive={!possuiErro}
                    negative={possuiErro}
                    header={
                        possuiErroPeriodo
                            ? 'Periodo nao encontrado'
                            : possuiErro
                            ? 'Problemas ao encontrar o pedido'
                            : 'Processado com sucesso'
                    }
                >
                    <Message.List>
                        {array.map((item, index) => (
                            <Message.Item
                                key={index}
                                style={{
                                    color: textoPossuiErro(item)
                                        ? 'red'
                                        : undefined
                                }}
                            >
                                {item}
                            </Message.Item>
                        ))}
                    </Message.List>
                </Message>
            </If>
            <div style={{ marginTop: '30px' }}>
                <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Tabela de Pedidos</p>

                {/* <If test={concirepasse.length > 0}> */}
                {boletopedidosloading ? (
                    <Loader active inline='centered'>Carregando...</Loader>
                ) : (
                    <StyledTable id={'concirepasselog'} compact='very' size='small' loading={true}>
                        <StyledTableHeader>
                            <Table.Row>
                                <Table.HeaderCell textAlign='center' width="1">Pedido</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="2">NomeParc</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="1">Nunota</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="1">Nufin</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="1">Valor Bruto</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="1">Valor Nota</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="1">DtPagamento</Table.HeaderCell>
                                <Table.HeaderCell textAlign='center' width="2">Observação</Table.HeaderCell>
                            </Table.Row>
                        </StyledTableHeader>

                        <StyledTableBody>

                            {boletopedidos.map(item => (
                                <StyledTableRow>
                                    <Table.Cell textAlign='center'>{item.ad_pedidofbits}</Table.Cell>
                                    <Table.Cell >{item.nomeparc}</Table.Cell>
                                    <Table.Cell textAlign='center'>{item.nunota}</Table.Cell>
                                    <Table.Cell textAlign='center'>{item.nufin}</Table.Cell>
                                    <Table.Cell textAlign='center'>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.vlrbruto)}</Table.Cell>
                                    <Table.Cell textAlign='center'>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.vlrnota)}</Table.Cell>
                                    <Table.Cell textAlign='center'>{moment(item.dtpagamento).format("DD/MM/YYYY hh:mm:ss")}</Table.Cell>
                                    <Table.Cell style={{ color: item.observacao === 'Pedido atualizado com sucesso.' ? 'green' : 'red' }} textAlign='center'>{item.observacao}</Table.Cell>
                                </StyledTableRow>

                            ))}


                        </StyledTableBody>
                    </StyledTable>
                )}

                {/* </If> */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    boletoarquivojson: state.MarketPlacesReducer.boletoarquivojson,
    boletoarquivojsonloading: state.MarketPlacesReducer.boletoarquivojsonloading,
    boletopedidos: state.MarketPlacesReducer.boletopedidos,
    boletopedidosloading: state.MarketPlacesReducer.boletopedidosloading
});

export default withRouter(connect(mapStateToProps, {
    marketplacesBoletoImportAction,
    marketplacesBoletoPedidosAction
})(Boleto));
